import React from "react";
import { delay, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
  containerVariants,
  itemVariants,
  photoVariants,
} from "../../variants/variants";

const Section2 = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-28">
      <motion.div
        initial="hidden"
        whileInView="visible"
        exit="exit"
        variants={containerVariants}
        className=" grid grid-cols-1 md:grid-cols-2 "
      >
        <div className="space-y-5  md:pr-14 pb-14 pt-14 md:pt-0 md:mt-0">
          <motion.p
            variants={itemVariants}
            className="text-20 font-light text-customGray"
          >
            {t("about.section2.text1")}
          </motion.p>

          <motion.p
            variants={itemVariants}
            className="text-20 font-light text-customGray"
          >
            {t("about.section2.text2")}
          </motion.p>
        </div>

        <div className="-order-1 md:order-none overflow-hidden">
          <motion.img
            initial="initial"
            whileInView="whileInView"
            exit="exit"
            variants={photoVariants}
            src="/images/about/1.jpg"
            className=" h-full w-full object-cover"
          />
        </div>
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        exit="exit"
        variants={containerVariants}
        className="  grid grid-cols-1 md:grid-cols-2"
      >
        <div className="overflow-hidden">
          <motion.img
            initial="initial"
            whileInView="whileInView"
            exit="exit"
            variants={photoVariants}
            src="/images/about/2.jpg"
            className="h-full w-full object-cover"
          />
        </div>

        <div className="space-y-5 py-14 md:p-14">
          <motion.p
            variants={itemVariants}
            className="text-20 font-light text-customGray"
          >
            {t("about.section2.text3")}
          </motion.p>
        </div>
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        exit="exit"
        variants={containerVariants}
        className=" grid grid-cols-1 md:grid-cols-2"
      >
        <div className="space-y-5 pt-14 md:pr-14  md:pb-14 ">
          <motion.p
            variants={itemVariants}
            className="text-20 font-light text-customGray"
          >
            {t("about.section2.text4")}
          </motion.p>
        </div>
        <div className="-order-1 md:order-none overflow-hidden">
          <motion.img
            initial="initial"
            whileInView="whileInView"
            exit="exit"
            variants={photoVariants}
            src="/images/about/3.jpg"
            className="h-full w-full object-cover"
          />
        </div>
      </motion.div>
    </div>
  );
};

export default Section2;
